export const base16Theme = {
  scheme: "monokai",
  author: "Vitaly Kumov based on Cisco UI kit",
  base00: "var(--cui-background-inactive)",
  base01: "#f2f2f2",
  base02: "#64bbe3",
  base03: "#b6b9bb",
  base04: "#39393b",
  base05: "#58585b",
  base06: "#626469",
  base07: "#ffffff",
  base08: "#14a792",
  base09: "#14a792",
  base0A: "#017cad",
  base0B: "#6cc04a",
  base0C: "#ffcc00",
  base0D: "#7f7f86",
  base0E: "#626469",
  base0F: "#626469",
};
